import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Table from 'components/application/Table';

import BookingsRow from 'components/bookings/BookingsRow';
import { useTabContext } from 'components/contexts/TabContext';

import {
  resourcesAsResourceMap,
  resourceShape,
} from 'components/helpers/serialisableResources';

export default function BookingsTable({ bookingConnections, onRowClick }) {
  const { selectedTabKey } = useTabContext();

  const { t: i18nTCommon } = useTranslation('common');

  // TODO decide on mutate vs copy
  const resourceMap = resourcesAsResourceMap({
    resources: bookingConnections.included,
    resourceTypes: ['course', 'booking', 'bookingGroup', 'personnel'],
  });

  const bookingConnectionsWithAssociatedRecords = bookingConnections.data.map(
    (bookingConnection) => {
      const bookingSourceReference =
        bookingConnection.relationships.source.data;

      const bookingSource =
        resourceMap[bookingSourceReference.type][bookingSourceReference.id];

      const course =
        resourceMap.course[bookingSource.relationships.course.data.id];

      const personnel =
        bookingSource.type === 'bookingGroup' ?
          bookingSource.relationships.limitedPersonnel.data.map(
            (personnel) => resourceMap.personnel[personnel.id],
          )
        : [
            resourceMap.personnel[
              bookingSource.relationships.personnel.data.id
            ],
          ];

      return {
        bookingConnection,
        bookingSource,
        course,
        personnel,
      };
    },
  );

  return (
    <Table
      headers={
        <tr>
          <th className='tw-w-auto tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTCommon('shared.course')}
          </th>
          <th className='tw-w-auto tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {i18nTCommon('shared.personnel')}
          </th>
          <th className='tw-w-30 tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {selectedTabKey === 'eLearning' ?
              i18nTCommon('courses.provider')
            : selectedTabKey === 'pastBookings' && i18nTCommon('shared.method')}
          </th>
          <th className='tw-w-50 tw-text-s tw-font-medium tw-tracking-wide tw-text-grey-900'>
            {selectedTabKey === 'eLearning' ?
              i18nTCommon('shared.status')
            : i18nTCommon('training.trainingDate')}
          </th>
        </tr>
      }
      rows={bookingConnectionsWithAssociatedRecords.map(
        (bookingConnectionDetails) => (
          <BookingsRow
            bookingConnection={bookingConnectionDetails.bookingConnection}
            bookingSource={bookingConnectionDetails.bookingSource}
            course={bookingConnectionDetails.course}
            key={bookingConnectionDetails.bookingConnection.id}
            onRowClick={onRowClick}
            personnel={bookingConnectionDetails.personnel}
          />
        ),
      )}
    />
  );
}

BookingsTable.propTypes = {
  bookingConnections: PropTypes.shape({
    data: PropTypes.arrayOf(resourceShape('bookingConnection')),
  }),
  onRowClick: PropTypes.func.isRequired,
};
